<template>
  <div class="container">
    <head-nav-bar
      :title="query.contact || noContact ? info.name : '选择就诊人'"
      :fixed="true"
    />
    <van-overlay :show="haveFormData">
      <div class="wrapper" @click.stop>
        <div class="block">抱歉！未查询到筛查表信息</div>
      </div>
    </van-overlay>
    <div class="mt-header-nav" v-if="query.contact || noContact">
      <div class="title">
        <p>{{ hospitalInfo.fullName }}</p>
        <p>{{ info.name }}</p>
      </div>
      <div
        class="TemplateText"
        style="white-space: pre-wrap"
        v-html="info.templateText"
      ></div>
      <div class="fieldBox">
        <van-form @submit="onSubmit">
          <van-cell size="large">
            <template #title>
              <van-tag type="primary">患者</van-tag>
            </template>
          </van-cell>
          <van-field
            v-model="userData.diagnosisCardNo"
            type="number"
            name="就诊卡号"
            label="就诊卡号"
            placeholder="请填写卡号"
            required
            :rules="[{ required: true }]"
            v-if="!noContact"
          />
          <van-field
            required
            v-model="userData.patientName"
            name="患者姓名"
            label="患者姓名"
            placeholder="请填写患者姓名"
            :rules="[{ required: true }]"
            @blur.stop="handleCardNoChange"
          />
          <van-field name="radio" required label="性别">
            <template #input>
              <van-radio-group
                v-model="userData.patientSex"
                direction="horizontal"
              >
                <van-radio name="1">男</van-radio>
                <van-radio name="2">女</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field
            required
            v-model="userData.patientAge"
            name="年龄"
            label="年龄"
            placeholder="请填写年龄"
            :rules="[{ required: true }]"
          />
          <van-field
            type="tel"
            maxlength="11"
            v-model="userData.patientContactPhone"
            name="电话"
            label="电话"
            placeholder="请填写电话"
            required
            :rules="[{ required: true }]"
          />
          <van-field
            v-model="userData.patientIdentityNo"
            name="身份证号"
            label="身份证号"
            placeholder="请填写身份证号"
            v-if="!noContact"
          />
          <van-field
            v-else
            v-model="userData.patientIdentityNo"
            name="身份证号"
            label="身份证号"
            placeholder="请填写身份证号"
            required
            :rules="[{ required: true }]"
          />
          <van-field
            v-model="userData.patientContactAddress"
            name="现住址"
            label="现住址"
            placeholder="请填写现住址"
          />
          <!-- 根据后台返回是否陪护展示 -->
          <van-field name="switch" label="有无家属陪同">
            <template #input>
              <van-switch v-model="userData.hasAccompanyPerson" size="0.5rem" />
            </template>
          </van-field>
          <div v-if="userData.hasAccompanyPerson">
            <van-cell size="large">
              <template #title>
                <van-tag type="warning">陪护人</van-tag>
              </template>
            </van-cell>
            <van-field
              v-model="userData.accompanyName"
              name="陪护姓名"
              label="陪护姓名"
              placeholder="请填写陪护姓名"
              required
              :rules="[{ required: true }]"
            />

            <van-field
              v-model="userData.relationTypeDesc"
              readonly
              class="readonly"
              label="与患者关系"
              placeholder="点击此处选择"
              @click="showRelation"
              required
              :rules="[{ required: true }]"
            />
            <van-field
              type="tel"
              maxlength="11"
              v-model="userData.accompanyPhone"
              name="电话"
              label="电话"
              placeholder="请填写电话"
              required
              :rules="[{ required: true }]"
            />
            <van-field
              v-model="userData.accompanyIdentityNo"
              label="身份证号"
              placeholder="请填写身份证号"
            />
            <van-field
              v-model="userData.accompanyContactAddress"
              name="现住址"
              label="现住址"
              placeholder="请填写现住址"
            />
          </div>

          <van-cell size="large">
            <template #title>
              <van-tag type="danger">流行病学史</van-tag>
            </template>
          </van-cell>
          <div
            class="detailsBox"
            v-for="(item, index) in info.details"
            :key="index"
            style="marginbottom: 0.2rem"
          >
            {{ index + 1 }}.{{ item.title }}
            <!-- 患者 -->
            <van-cell size="large">
              <template #title>
                <van-tag type="warning">患者</van-tag>
              </template>
            </van-cell>

            <van-field required :rules="[{ required: true }]">
              <template #input>
                <van-radio-group
                  style="margin: 0.2rem 0"
                  v-model="userData.details[index].mainOperateType"
                  direction="horizontal"
                >
                  <van-radio name="1">是</van-radio>
                  <van-radio name="2">否</van-radio>
                </van-radio-group>
              </template>
            </van-field>

            <van-field
              v-if="
                userData.details[index].mainOperateType == 1 &&
                  item.details.length > 0
              "
              v-model="userData.details[index].mainOperateItemText"
              readonly
              class="readonly"
              placeholder="点击此处选择"
              @click="showQuetions(index)"
              required
              :rules="[{ required: true }]"
            />
            <van-field
              v-if="
                userData.details[index].mainOperateType == 1 &&
                  userData.details[index].backup01 == 'true'
              "
              v-model="userData.details[index].mainOperateRemark"
              name="备注"
              label-width="0.4rem"
              type="textarea"
              show-word-limit
              maxlength="50"
              placeholder="请填写备注"
              required
              :rules="[{ required: true }]"
            />
            <!-- 陪护人 -->
            <div v-if="userData.hasAccompanyPerson">
              <van-cell size="large">
                <template #title>
                  <van-tag type="primary">陪护人</van-tag>
                </template>
              </van-cell>
              <van-field required :rules="[{ required: true }]">
                <template #input>
                  <van-radio-group
                    style="margin: 0.2rem 0"
                    v-model="userData.details[index].accompanyOperateType"
                    direction="horizontal"
                  >
                    <van-radio name="1">是</van-radio>
                    <van-radio name="2">否</van-radio>
                  </van-radio-group>
                </template>
              </van-field>
              <van-field
                v-if="
                  userData.details[index].accompanyOperateType == 1 &&
                    item.details.length > 0
                "
                v-model="userData.details[index].accompanyOperateItemText"
                readonly
                class="readonly"
                placeholder="点击此处选择"
                @click="showQuetions2(index)"
                required
                :rules="[{ required: true }]"
              />

              <van-field
                v-if="
                  userData.details[index].accompanyOperateType == 1 &&
                    userData.details[index].backup02 == 'true'
                "
                v-model="userData.details[index].accompanyOperateRemark"
                name="备注"
                label-width="0.4rem"
                type="textarea"
                show-word-limit
                maxlength="50"
                placeholder="请填写备注"
                required
                :rules="[{ required: true }]"
              />
            </div>
          </div>
          <div class="TemplateText" v-html="info.tipsRemark"></div>
          <div style="margin: 16px">
            <van-button
              round
              block
              type="info"
              :disabled="submitDisabled"
              native-type="submit"
              >提交</van-button
            >
          </div>
        </van-form>
      </div>
    </div>
    <div v-else class="mt-header-nav chooseContact">
      <span v-for="(item, index) in contactList" :key="index">
        <van-button
          @click="chooseContact(item)"
          style="margin: 0 10px"
          size="small"
          type="info"
          >{{ item.cardholderName }}</van-button
        >
      </span>
      <van-button
        @click="chooseContact()"
        type="primary"
        size="small"
        style="margin: 0 10px"
        >无就诊卡</van-button
      >
    </div>
    <van-overlay :show="chooseContactJump">
      <div class="wrapper" @click.stop>
        <!-- <div class="block"> -->
        <van-loading />
        <!-- </div> -->
      </div>
    </van-overlay>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import SelectPicker from "@/components/select-picker/function";
import { getSelectData, postConfirm } from "@/utils/common";
import {
  Form,
  Field,
  Button,
  RadioGroup,
  Radio,
  Cell,
  CellGroup,
  Popup,
  Picker,
  Tag,
  Switch,
  Dialog,
  Overlay,
  Notify,
  Loading
} from "vant";
export default {
  components: {
    [Field.name]: Field,
    [Button.name]: Button,
    [Form.name]: Form,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Popup.name]: Popup,
    [Picker.name]: Picker,
    [Tag.name]: Tag,
    [Switch.name]: Switch,
    [Overlay.name]: Overlay,
    [Notify.name]: Notify,
    [Loading.name]: Loading
  },
  computed: {
    ...mapState({
      hospitalInfo: state => state.app.hospitalInfo
    })
  },
  // 获取上一页路由信息 用于判断是否扫码进入
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.fromPath = from.path;
    });
  },

  data() {
    return {
      noContact: false,
      patientName: "",
      info: {},
      mobilePhone: "",
      identityNo: "",
      userData: {
        cardBookingId: "", //每个CardBookingId字段值都固定
        diagnosisCardNo: "",
        patientName: "",
        patientSex: "",
        patientAge: "",
        departmentId: "",
        departmentName: "",
        patientContactPhone: "",
        patientIdentityNo: "",
        patientContactAddress: "",
        hasAccompanyPerson: false,
        accompanyName: "",
        accompanyPhone: "",
        screeningFormTemplateId: "",
        epidemicType: 1,
        screeningFormName: "",
        hisPatientNo: "",
        relationType: "",
        relationTypeDesc: "",

        tipsRemark: "",
        templateText: "",
        details: []
      },
      columns: [],
      columnsSelect: [],
      showPicker: false,
      infoDetailsSelect: [],
      infoDetails: [],
      subject: [],
      value: "",
      selectIndex: "",
      selectData: {},
      selectPickerModal: "",
      fromPath: "",
      confirmApi: "",
      confirmJson: "",
      haveFormData: false,
      submitDisabled: false,
      // cannotSubmit: false
      query: {},
      contactList: [],
      chooseContactJump: false
    };
  },
  created() {
    const query = this.$route.query;
    setTimeout(() => {
      if (query && query.contact) {
        // 执行从预约挂号进入该页面的逻辑
        this.reserveIn(query);
      } else {
        // 执行从微信公众号进入该页面的逻辑
        this.wechatIn();
      }
    }, 500);
  },
  methods: {
    ...mapActions(["getHospitalInfo"]),
    wechatIn() {
      this.getContact();
    },
    // 获取就诊人列表
    getContact() {
      this.$post("Contact_List").then(res => {
        this.contactList = res.data.datas;
      });
    },
    chooseContact(contactInfo) {
      this.chooseContactJump = true;
      setTimeout(() => {
        if (contactInfo) {
          this.reserveIn({ contact: contactInfo });
        } else {
          // 点击无就诊人逻辑
          this.noContact = true;
          this.reserveIn();
        }
        this.chooseContactJump = false;
      }, 1000);
    },
    reserveIn(query) {
      if (query) {
        this.query = query;
      }
      if (query && query.DepartmentId) {
        this.userData.departmentId = query.DepartmentId;
      }
      if (query && query.DepartmentName) {
        this.userData.departmentName = query.DepartmentName;
      }
      if (query && query.contact && query.contact.diagnosisCardNo) {
        this.userData.diagnosisCardNo = query.contact.diagnosisCardNo;
      }
      if (query && query.contact && query.contact.cardholderName) {
        this.userData.patientName = query.contact.cardholderName;
        this.handleCardNoChange("", query.contact.cardholderName);
      }
      if (query && query.api) {
        this.confirmApi = query.api;
      }
      if (query && query.json) {
        this.confirmJson = query.json;
      }
      if (query && query.user) {
        this.confirmUser = query.user;
      }
      if (!(this.hospitalInfo && this.hospitalInfo.id)) {
        this.getHospitalInfo();
      }
      // 获取后台配置
      this.$post("GetScreeningForm_InfoAsync", { epidemicType: 1 }).then(
        res => {
          if (res.data == null) {
            this.haveFormData = true;
          }
          this.info = res.data;
          this.userData.tipsRemark = this.info.tipsRemark;
          this.userData.templateText = this.info.templateText;
          this.userData.hasAccompanyPerson = this.info.hasAccompanyPerson;
          this.userData.screeningFormTemplateId = this.info.screeningFormTemplateId;
          this.userData.screeningFormName = this.info.name;
          this.info.details.forEach(element => {
            this.subject.push({ itemText: "" });
            this.userData.details.push({
              cardBookingId: "", //预约Id - 每个CardBookingId字段值都固定
              optionTemplateId: element.id, //选项模板Id
              optionTemplateTitle: element.title, //选项模板
              mainOperateType: null, //患者选项 -
              mainOperateItemId: "", //选择项Id
              mainOperateItemText: "", //选择项
              mainOperateRemark: "", //	备注
              accompanyOperateType: null, //陪护选项
              accompanyOperateItemId: "", //选择项Id
              accompanyOperateItemText: "", //选择项
              accompanyOperateRemark: "" //备注
            });
          });
        }
      );
      // 获取科室
      this.$post("Department_Tree", {}).then(res => {
        this.columns = res.data.departmentList;
      });
      getSelectData(["RelationType"]).then(res => {
        this.selectData = res;
      });
    },
    // 提交筛查表
    onSubmit() {
      const _this = this;
      // if (this.cannotSubmit) {
      //   Notify("未找到指定卡号信息，请检查卡号是否正确！");
      //   return;
      // }
      if (!this.noContact) {
        _this
          .$post("His_PersonInfo", {
            diagnosisCardNo: _this.userData.diagnosisCardNo,
            name: _this.userData.patientName
          })
          .then(() => {
            _this.lastSubmit();
          });
      } else {
        this.lastSubmit();
      }
    },
    lastSubmit() {
      const _this = this;
      if (_this.userData.diagnosisCardNo) {
        _this.userData.cardBookingId = 0;
        _this.userData.details.map(p => {
          p.cardBookingId = 0;
        });
      }
      if (_this.fromPath == "/serve/pre-order/confirm") {
        postConfirm(
          _this,
          _this.confirmApi,
          _this.confirmJson,
          _this.userData,
          _this.confirmUser
        );
      } else {
        if (
          !_this.noContact &&
          _this.userData.patientIdentityNo != _this.identityNo
        ) {
          _this.userData.patientIdentityNo = _this.identityNo;
        }
        if (
          !_this.noContact &&
          _this.userData.patientContactPhone != _this.mobilePhone
        ) {
          _this.userData.patientContactPhone = _this.mobilePhone;
        }
        _this.submitDisabled = true;
        _this
          .$post("AddScreeningForm_RecordAsync", _this.userData)
          .then(res => {
            if (res.data) {
              _this.submitDisabled = false;
              Dialog.confirm({
                message: "提交成功！"
              })
                .then(() => {
                  // _this.$router.go(0);
                  this.$router.replace({
                    name: "CheckScreeningForm",
                    query: {
                      DiagnosisCardNo: _this.userData.diagnosisCardNo,
                      PatientName: _this.userData.patientName,
                      noContact: _this.noContact
                    }
                  });
                })
                .catch(() => {
                  _this.$router.go(0);
                });
            } else {
              Dialog.alert({
                message: "提交失败"
              }).then(() => {
                // on close
              });
            }
            return false;
          });
      }
    },
    onConfirm(value) {
      this.subject[this.selectIndex].itemText = value;
      this.userData.details[this.selectIndex].mainOperateItemText = value;
      this.info.details[this.selectIndex].details.map(p => {
        if (p.itemText === value) {
          this.userData.details[this.selectIndex].mainOperateItemId = p.itemId;
        }
      });
      this.showPicker = false;
    },
    AccompanyOnConfirm(value) {
      this.subject[this.selectIndex].itemText = value;
      this.userData.details[this.selectIndex].accompanyOperateItemText = value;
      this.info.details[this.selectIndex].details.map(p => {
        if (p.itemText === value) {
          this.userData.details[this.selectIndex].accompanyOperateItemId =
            p.itemId;
        }
      });
      this.showPicker = false;
    },
    renderSelect(e, index) {
      this.selectIndex = index;
      this.infoDetailsSelect = e.map(p => {
        return p.itemText;
      });
    },
    showRelation() {
      const _this = this;
      this.selectPickerModal = SelectPicker({
        columns: this.selectData.RelationType,
        defaultValue: this.userData.relationType,
        change: data => {
          _this.userData.relationType = data.id;
          _this.userData.relationTypeDesc = data.text;
        }
      });
    },
    showDepartment() {
      const _this = this;
      this.selectPickerModal = SelectPicker({
        columns: this.columns,
        defaultValue: this.userData.departmentId,
        change: data => {
          _this.userData.departmentId = data.id;
          _this.userData.departmentName = data.text;
        }
      });
    },
    showQuetions(index) {
      const _this = this;
      this.selectPickerModal = SelectPicker({
        columns: this.info.details[index].details,
        defaultValue: this.userData.details[index].mainOperateItemId,
        change: data => {
          _this.userData.details[index].backup01 = data.backup01;
          _this.userData.details[index].mainOperateItemId = data.id;
          _this.userData.details[index].mainOperateItemText = data.text;
        }
      });
    },
    showQuetions2(index) {
      const _this = this;
      this.selectPickerModal = SelectPicker({
        columns: this.info.details[index].details,
        defaultValue: this.userData.details[index].accompanyOperateItemId,
        change: data => {
          _this.userData.details[index].backup02 = data.backup01;
          _this.userData.details[index].accompanyOperateItemId = data.id;
          _this.userData.details[index].accompanyOperateItemText = data.text;
        }
      });
    },
    getPatientName(value) {
      this.patientName = value;
      console.log(this.patientName);
    },
    handleCardNoChange(e, name) {
      if (this.noContact) return;
      // event.stopPropagation();
      let value = "";
      if (e && e !== "") {
        value = e.target.value;
      } else if (name) {
        value = name;
      }
      if (value) {
        this.$post("His_PersonInfo", {
          diagnosisCardNo: this.userData.diagnosisCardNo,
          name: value
        })
          .then(res => {
            const cardData = res.data;
            // this.cannotSubmit = false;
            if (cardData && cardData.diagnosisCardNo) {
              if (!this.userData.cardholderSexName) {
                this.userData.patientSex = cardData.Sex == "男" ? "1" : "2";
              }
              if (!this.userData.patientAge) {
                this.userData.patientAge = cardData.Age;
              }
              if (!this.userData.patientContactPhone) {
                this.userData.patientContactPhone =
                  cardData.mobilePhoneProtected;
                this.mobilePhone = cardData.mobilePhone;
              }
              if (!this.userData.patientIdentityNo) {
                this.userData.patientIdentityNo = cardData.identityNoProtected;
                this.identityNo = cardData.identityNo;
              }
              if (!this.userData.patientContactAddress) {
                this.userData.patientContactAddress = cardData.contactAddress;
              }
            }
          })
          .catch(() => {
            // this.cannotSubmit = true;
          });
      }
    }
  }
};
</script>

<style lang="less" scoped>
.container {
  .title {
    width: 100%;
    text-align: center;
    font-weight: bold;
    font-size: 0.5rem;
    margin-bottom: 0.5rem;
  }

  .fieldBox {
  }

  .needHasAccompanyPerson {
    padding-left: 0.4rem;
    font-size: 0.4rem;
    color: red;
  }
  .TemplateText {
    font-size: 0.4rem;
    padding: 0 0.4rem;
  }
  .detailsBox {
    padding: 0 0.4rem;
    font-size: 0.4rem;
  }
  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    .block {
      padding: 0.5rem 1rem;
      border-radius: 5px;
      background-color: #fff;
      font-size: 0.4rem;
      font-weight: bold;
    }
  }
}
</style>
